import { render, staticRenderFns } from "./OcorrenciasApp.vue?vue&type=template&id=281bb7c6&"
import script from "./OcorrenciasApp.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports